<!-- Confirmation: delete  -->
<p-confirmDialog key="confirm-delete-dialog" (onHide)="onHideAction()" [draggable]="false" [closable]="true">
  <ng-template pTemplate="header">
    <span data-testid="dialog-title" class="p-dialog-title">{{ title | translate }}</span>
  </ng-template>
  <ng-template pTemplate="message">
    <div class="w-full">

      @if (deleteCheckResponses) {
        @if (!canDelete) {
          <div class="delete-check-message delete-check-message-blocked">
            <p>{{ 'MODALBOXES.DESCRIPTION_DELETE_NOT_ALLOWED' | translate }}</p>
          </div>

          @for (deleteCheckResponse of deleteCheckResponses; track $index) {
            @if (deleteCheckResponses.length > 1 && deleteCheckResponse.identifier) {
              <p class="delete-check-identifier">{{ deleteCheckResponse.identifier }}</p>
            }

            @if (deleteCheckResponse.dependencies?.length) {
              <div class="delete-check-details">
                <p class="delete-check-heading">{{ 'MODALBOXES.LABEL_DEPENDENCIES_PREVENTING_DELETE' | translate }}</p>

                <ul class="delete-check-list">
                  @for (dependency of deleteCheckResponse.dependencies; track $index) {
                    <li class="delete-check-list-item">
                      <span>{{ dependency.name }}</span>
                      <strong>{{ dependency.count }}</strong>
                    </li>
                  }
                </ul>
              </div>
            }
          }
        } @else if (hasRelationships) {
          <div class="delete-check-message">
            <p>{{ 'MODALBOXES.DESCRIPTION_DELETE_WITH_RELATIONSHIPS' | translate }}</p>
          </div>

          @for (deleteCheckResponse of deleteCheckResponses; track $index) {
            @if (deleteCheckResponses.length > 1 && deleteCheckResponse.identifier) {
              <p class="delete-check-identifier">{{ deleteCheckResponse.identifier }}</p>
            }

            @if (deleteCheckResponse.relationships?.length) {
              <div class="delete-check-details">
                <p class="delete-check-heading">{{ 'MODALBOXES.LABEL_RELATIONSHIPS_TO_UNLINK' | translate }}</p>
                <ul class="delete-check-list">
                  @for (relationship of deleteCheckResponse.relationships; track $index) {
                    <li class="delete-check-list-item">
                      <span>{{ relationship.name }}</span>
                      <strong>{{ relationship.count }}</strong>
                    </li>
                  }
                </ul>
              </div>
            }
          }
        } @else {
          <div class="delete-check-message">
            <p>{{ 'MODALBOXES.DESCRIPTION_DELETE_WITHOUT_RELATIONSHIPS' | translate }}</p>
          </div>
        }
      }

      <label data-testid="dialog-label" for="deleteReason" class="mb-2">{{ 'MODALBOXES.LABEL_DELETE_REASON' | translate }} <i class="icon-required-field"></i>
      </label>

      <textarea #reasonField="ngModel" [(ngModel)]="reason" required data-testid="dialog-text-area" class="text-sm" rows="3" id="deleteReason"></textarea>

      @if (reasonField.invalid && (reasonField.touched || reasonField.dirty)) {
        <small data-testid="reason-required" class="error">
          {{ 'MODALBOXES.HINT_REASON_REQUIRED' | translate }}.
        </small>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button data-testid="btn-cancel" type="button" class="btn outline-btn" (click)="onCancel()">{{
    'MODALBOXES.BTN_CANCEL' | translate }}</button>
    <button data-testid="btn-confirm" type="button" class="btn primary-btn" (click)="onConfirm()" [disabled]="!canDelete || !reason.trim()">{{
    'MODALBOXES.BTN_CONFIRM' | translate }}</button>
  </ng-template>
</p-confirmDialog>
